import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { SelectAbstractComponent, ProductParams } from '../select-abstract';
import { Product } from '@schoolbelle/api/purchase';
import { sortBy } from 'lodash';
import { PurchaseService } from '@schoolbelle/api/purchase';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-select-sms',
  templateUrl: './select-sms.component.html',
  styleUrls: ['./select-sms.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class SelectSmsComponent extends SelectAbstractComponent implements OnInit {
  predefined = [10000, 20000, 30000, 40000];
  customAmountCtrl:FormControl;

  @Input() test:boolean = false;
  @Input() form:FormGroup;
  @Input() required:boolean = false;
  @Input() products:ProductParams[] = [];
  @Output() productsChange = new EventEmitter<ProductParams[]>();
  

  sms:Product;
  oldProducts:Product[] = []
  constructor (
    purchase:PurchaseService,
  ) {
    super(purchase);
  }
  ngOnInit(): void {
    // validate the form which values inside sms custom input form
    this.customAmountCtrl = new FormControl(null, [
      // this.test ? Validators.min(10) : Validators.min(1000),
      Validators.min(1000),
      (ctrl:AbstractControl)=>{ 
        //
        if(ctrl.value) {
          if(ctrl.value % 10 !== 0) {
            return { unit:true }
          } else if(ctrl.value.toString().length > 6) {
            return { maxvalue:true }
          }
        }

        // if (ctrl.value && ctrl.value % 10 !== 0) {
        //   return { unit:true }
        // }
        return null;
      }
    ]);
    this.oldProducts = sortBy(
      this.purchase.currentProducts.filter(p=>p.product_id <= 49 && (<any>p).type.includes('sms')), 
      ({product_name})=>{
        return typeof product_name === 'string' && Number((<string>product_name).replace(/\D/g, '')) || 0 
      }
    );


    this.setProducts();
    
    super.ngOnInit();

    this.customAmountCtrl.valueChanges.pipe(debounceTime(100)).subscribe((amount)=>{
      if (this.customAmountCtrl.invalid) this.onCustomAmountCtrlUpdate(null);
      else this.onCustomAmountCtrlUpdate(amount)
    });

    this.setIndex();
  }
  private setProducts () {
    this.sms = this.purchase.currentProducts.find(product=>{
      // return [57].includes(product.product_id);
      return [61].includes(product.product_id);
    });
  }
  protected setIndex () {
    // const sms = this.products.find(p=>p.productId === 57);
    const sms = this.products.find(p=>[57,61].includes(p.productId));
    if (sms) {
      if (this.predefined.includes(sms.amount)) {
        this.indexCtrl.setValue(sms.amount);
      }
      else {
        this.indexCtrl.setValue('custom');
        this.customAmountCtrl.setValue(sms.amount);
      }
    }
    else if (this.products.length) {
      const product_id = this.products[0].productId;
      const product = this.purchase.currentProducts.find(p=>p.product_id === product_id);

      if (product) {
        this.indexCtrl.setValue(product);
      }
    }
  }


  
  onUpdate (amount:number|'custom'|Product) {
    if (amount === 'custom') {
      this.products = [];
      this.productsChange.next(this.products);        
      this.customAmountCtrl.setValue(null);
    }
    else if (typeof amount === 'number' || amount === null) {
      let products:ProductParams[] = [];
      if (typeof amount === 'number') {
        // products.push({productId:57, amount});
        products.push({productId:61, amount});
      } 
      this.products = products;
      this.productsChange.next(this.products);    
    }
    else {
      this.products = [{productId:amount.product_id, amount:1}];
      this.productsChange.next(this.products);        
    }  
  }
  onCustomAmountCtrlUpdate (amount:number) {
    let products:ProductParams[] = [];
    if (typeof amount === 'number') {
      // products.push({productId:57, amount});
      products.push({productId:61, amount});
    } 
    this.products = products;
    this.productsChange.next(this.products);    
  }
}
